import { render } from "./TheProductTabs.vue?vue&type=template&id=2c9ea9ec&ts=true"
import script from "./TheProductTabs.vue?vue&type=script&lang=ts"
export * from "./TheProductTabs.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__